module.exports = __webpack_public_path__ + "static/media/back-lime.0589482b.png";